(function(){
    'use strict';

    angular
        .module('elogbooks.admin.permissions-overview')
        .config(registerRoutes)
        .config(registerRoutesListSitePermissions)
        .config(registerRoutesListUserPermissions)
        .config(registerRoutesListReportPermissions)
        .config(registerRoutesListOperativePermissions)
        .config(registerUsersByPermissionRoutesPerTab)
        .config(registerUrlMatchers)
    ;

    function registerUrlMatchers($urlMatcherFactoryProvider) {
        /**
         * Report permissions are stored in the backend using the format: user_permission_report_<NAME>
         * Business want to display them as: report_permission_<NAME>
         *
         * This ensures the user sees the URL required by business and the backend still receives the original code
         */
        $urlMatcherFactoryProvider.type('reportCode', {
            encode: function(value) {
                //value = 'user_permission_report_summary'
                const parts = value.split('_'); // ['user','permission','report','summary']

                //remove the leading "user"
                parts.shift(); // ['permission','report','summary']

                //swap permisson + report → report_permission_summary
                const [a, b, ...rest] = parts;
                return [b, a, ...rest].join('_');
            },
            decode: function(value) {
                //value = 'report_permission_summary'
                const parts = value.split('_'); // ['report','permission','summary']

                //revert the swap → permission_report_summary
                const [a, b, ...rest] = parts;
                const reordered = [b, a, ...rest]; // ['permission','report','summary']

                //add back the user_ prefix
                return 'user_' + reordered.join('_');
            }
        });
    }

    function registerRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.admin.permissions-overview', {
                url: '/permissions-overview',
                abstract: true,
                templateUrl: '/modules/admin/permissions-overview/permissions-overview.html',
                ncyBreadcrumb: {
                    label: '{{ ::"PERMISSIONS_OVERVIEW" | translate }}'
                },
                data: {
                    permissions: ['user_permission_view_permissions']
                }
            });
    }

    function registerRoutesListSitePermissions ($stateProvider) {
        $stateProvider
            .state('dashboard.admin.permissions-overview.site-permissions', {
                parent: 'dashboard.admin.permissions-overview',
                data: {
                    permissions: ['user_permission_view_permissions']
                },
                url: '/site-premissions?sitePermissionPage&sitePermissionLimit&sitePermissionPermission&sitePermissionDescription',
                views: {
                    '@dashboard.admin.permissions-overview': {
                        templateUrl: '/modules/admin/permissions-overview/permissions-list.html',
                        controller: 'CommonPermissionsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    config: (sitePermissions, rootResourceResponse) => {
                        return {
                            permissionService: sitePermissions,
                            entityName: 'SITE_PERMISSIONS',
                            entityPrefix: 'sitePermission',
                            viewUsersAvailable: !!rootResourceResponse.getLink('users-by-permission')
                        }
                    }
                },
                params: {
                    sitePermissionPage: '1',
                    sitePermissionLimit: '30',
                    sitePermissionPermission: null,
                    sitePermissionDescription: null
                },
                ncyBreadcrumb: {
                    label: '{{ ::"SITE_PERMISSIONS" | translate }}'
                }
            });
    }

    function registerRoutesListUserPermissions ($stateProvider) {
        $stateProvider
            .state('dashboard.admin.permissions-overview.user-permissions', {
                parent: 'dashboard.admin.permissions-overview',
                data: {
                    permissions: ['user_permission_view_permissions']
                },
                url: '/user-permissions?userPermissionPage&userPermissionLimit&userPermissionPermission&userPermissionDescription',
                views: {
                    '@dashboard.admin.permissions-overview': {
                        templateUrl: '/modules/admin/permissions-overview/permissions-list.html',
                        controller: 'CommonPermissionsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    config: (userPermissions, rootResourceResponse) => {
                        return {
                            permissionService: userPermissions,
                            entityName: 'USER_PERMISSIONS',
                            entityPrefix: 'userPermission',
                            viewUsersAvailable: !!rootResourceResponse.getLink('users-by-permission')
                        }
                    }
                },
                params: {
                    userPermissionPage: '1',
                    userPermissionLimit: '30',
                    userPermissionPermission: null,
                    userPermissionDescription: null
                },
                ncyBreadcrumb: {
                    label: '{{ ::"USER_PERMISSIONS" | translate }}'
                }
            });
    }

    function registerRoutesListReportPermissions ($stateProvider) {
        $stateProvider
            .state('dashboard.admin.permissions-overview.report-permissions', {
                parent: 'dashboard.admin.permissions-overview',
                data: {
                    permissions: ['user_permission_view_permissions']
                },
                url: '/report-permissions?reportPermissionPage&reportPermissionLimit&reportPermissionPermission&reportPermissionDescription',
                views: {
                    '@dashboard.admin.permissions-overview': {
                        templateUrl: '/modules/admin/permissions-overview/permissions-list.html',
                        controller: 'CommonPermissionsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    config: (reportPermissions, rootResourceResponse) => {
                        return {
                            permissionService: reportPermissions,
                            entityName: 'REPORT_PERMISSIONS',
                            entityPrefix: 'reportPermission',
                            viewUsersAvailable: !!rootResourceResponse.getLink('users-by-permission')
                        }
                    }
                },
                params: {
                    reportPermissionPage: '1',
                    reportPermissionLimit: '30',
                    reportPermissionPermission: null,
                    reportPermissionDescription: null
                },
                ncyBreadcrumb: {
                    label: '{{ ::"REPORT_PERMISSIONS" | translate }}'
                }
            });
    }

    function registerRoutesListOperativePermissions ($stateProvider) {
        $stateProvider
            .state('dashboard.admin.permissions-overview.operative-permissions', {
                parent: 'dashboard.admin.permissions-overview',
                data: {
                    permissions: ['user_permission_view_permissions']
                },
                url: '/operative-permissions?operativePermissionPage&operativePermissionLimit&operativePermissionPermission&operativePermissionDescription',
                views: {
                    '@dashboard.admin.permissions-overview': {
                        templateUrl: '/modules/admin/permissions-overview/permissions-list.html',
                        controller: 'CommonPermissionsListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    config: (operativePermissions, rootResourceResponse) => {
                        return {
                            permissionService: operativePermissions,
                            entityName: 'OPERATIVE_PERMISSIONS',
                            entityPrefix: 'operativePermission',
                            viewUsersAvailable: !!rootResourceResponse.getLink('users-by-permission')
                        }
                    }
                },
                params: {
                    operativePermissionPage: '1',
                    operativePermissionLimit: '30',
                    operativePermissionPermission: null,
                    operativePermissionDescription: null
                },
                ncyBreadcrumb: {
                    label: '{{ ::"OPERATIVE_PERMISSIONS" | translate }}'
                }
            });
    }

    function registerUsersByPermissionRoutesPerTab($stateProvider) {
        const params = {
            usersPage: '1',
            usersLimit: '30',
            usersOrder: 'id',
            usersId: null,
            usersName: null,
            usersUsername: null,
            usersEmail: null,
            usersStatus: null
        };

        const common = {
            url: '/users-by-permission/:code?usersPage&usersLimit&usersOrder&usersId&usersName&usersUsername&usersEmail&usersStatus',
            data: { permissions: ['user_permission_view_permissions'] },
            views: {
                '@dashboard.admin.permissions-overview': {
                    templateUrl: '/modules/admin/permissions-overview/users-by-permission.html',
                    controller: 'UsersByPermissionController',
                    controllerAs: 'vm'
                }
            },
            params: params,
            resolve: {
                usersCollectionResponse: function($stateParams, rootResourceResponse, apiClient) {
                    return $stateParams.code ? apiClient.get(rootResourceResponse.getLink('users-by-permission'), {
                        page: $stateParams.usersPage || params.usersPage,
                        limit: $stateParams.usersLimit || params.usersLimit,
                        order: $stateParams.usersOrder || params.usersOrder,
                        code: $stateParams.code,
                        userId: $stateParams.usersId,
                        name: $stateParams.usersName,
                        username: $stateParams.usersUsername,
                        email: $stateParams.usersEmail,
                        status: $stateParams.usersStatus
                    }).then(function(response) {
                        return response || apiClient.noResourceFound();
                    }) : apiClient.noResourceFound();
                },
                permissionTranslation: function($stateParams, $translate, permissionPrefixKey) {
                    const codeKey = ($stateParams.code || '').toUpperCase();
                    const prefix = permissionPrefixKey ? $translate.instant(permissionPrefixKey) : '';
                    const code = codeKey ? $translate.instant(codeKey) : '';
                    return (prefix ? (prefix + ' ') : '') + code;
                },
                access: function(modules, modulesService, $state, lodash, messenger, $q) {
                    return checkModuleAccess(modules, modulesService, $state, lodash, messenger, $q);
                }
            },
            ncyBreadcrumb: {
                label: '{{ ::permissionTranslation }}'
            }
        };

        const siteUsersByPermission = angular.copy(common);
        siteUsersByPermission.resolve = angular.extend({}, common.resolve, {
            permissionPrefixKey: function() { return 'SITE_PERMISSION_OVERVIEW'; },
            modules: getModulesResolve('sitePermissions')
        });
        $stateProvider.state('dashboard.admin.permissions-overview.site-permissions.users-by-permission', siteUsersByPermission);

        const userUsersByPermission = angular.copy(common);
        userUsersByPermission.resolve = angular.extend({}, common.resolve, {
            permissionPrefixKey: function() { return 'USER_PERMISSION'; },
            modules: getModulesResolve('userPermissions')
        });
        $stateProvider.state('dashboard.admin.permissions-overview.user-permissions.users-by-permission', userUsersByPermission);

        const reportUsersByPermission = angular.copy(common);
        reportUsersByPermission.resolve = angular.extend({}, common.resolve, {
            permissionPrefixKey: function() { return 'REPORT_PERMISSION'; },
            modules: getModulesResolve('reportPermissions')
        });
        $stateProvider.state('dashboard.admin.permissions-overview.report-permissions.users-by-permission', reportUsersByPermission);

        const operativeUsersByPermission = angular.copy(common);
        operativeUsersByPermission.resolve = angular.extend({}, common.resolve, {
            permissionPrefixKey: function() { return 'OPERATIVE_PERMISSION'; },
            modules: getModulesResolve('operativePermissions')
        });
        $stateProvider.state('dashboard.admin.permissions-overview.operative-permissions.users-by-permission', operativeUsersByPermission);
    }

    function getModulesResolve(permissionServiceName) {
        return [permissionServiceName, '$stateParams', 'lodash', function(permissionService, $stateParams, lodash) {
            var permissionName = $stateParams.code;
            if (!permissionName) return [];
            var permissions = permissionService.getAllAsObjects();
            var permission = lodash.find(permissions, {name: permissionName});
            return (permission && permission.module) ? [permission.module] : [];
        }];
    }

    function checkModuleAccess(modules, modulesService, $state, lodash, messenger, $q) {
        if (modules && modules.length > 0) {
            if (!modulesService.oneOfEnabled(modules)) {
                $state.go('dashboard.user.dashboard', {}, {reload: true}).then(function() {
                    messenger.error('MODULE_NOT_ENABLED', {module: lodash.startCase(modules[0].replace(/_module$/, ''))});
                });
                return $q.reject('MODULE_DISABLED_REDIRECT');
            }
        }
        return true;
    }
})();
